// extracted by css-extract-rspack-plugin
export default {"root":"root-Qi6rom","empty":"empty-QMBHp1 text-sm","filters":"filters-BeTt0V","childLabel":"childLabel-aoaur7","childLabelText":"childLabelText-RqvQRZ text-xs-semibold"};